import { render, staticRenderFns } from "./MemberSave.vue?vue&type=template&id=53497e8a&scoped=true&"
import script from "./MemberSave.vue?vue&type=script&lang=js&"
export * from "./MemberSave.vue?vue&type=script&lang=js&"
import style0 from "./MemberSave.vue?vue&type=style&index=0&id=53497e8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53497e8a",
  null
  
)

export default component.exports